import {
  FooterStyled,
  FooterInner,
  Columns,
  List,
  Pair,
  ListTerm,
  ListDescription,
} from './styled'

import { SocialMedia } from '../social'
export const Footer = () => {
  return (
    <FooterStyled>
      <FooterInner>
        <Columns>
          <h3>Над проектом работали:</h3>
          <List>
            <Pair>
              <ListTerm>Режиссер</ListTerm>
              <ListDescription>Максим Миронов</ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Продюсер</ListTerm>
              <ListDescription>Виктор Кулганек</ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Редактор</ListTerm>
              <ListDescription>Анна Мороз</ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Операторы</ListTerm>
              <ListDescription className="comma">
                Мартин Бубеник, Дамир Есембаев, Петр Йилемницкий, Роман
                Конечный, Микола Лебедев, Руслан Лобань, Криштоф Майкснер,
                Энтони Мерфи, Ярослав Птачник, Павлина Вечержова, Вацлав
                Вршецкий
              </ListDescription>
              <ListDescription className="comma">
                Мартин Бубеник
                <br />
                Дамир Есембаев
                <br />
                Петр Йилемницкий
                <br />
                Роман Конечный
                <br />
                Микола Лебедев
                <br />
                Руслан Лобань
                <br />
                Криштоф Майкснер
                <br />
                Энтони Мерфи
                <br />
                Ярослав Птачник
                <br />
                Павлина Вечержова
                <br />
                Вацлав Вршецкий
              </ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Цветокоррекция</ListTerm>
              <ListDescription>Криштоф Майкснер</ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Режиссеры монтажа</ListTerm>
              <ListDescription className="comma">
                Дамир Есембаев, Максим Миронов, Анна Навумчик
              </ListDescription>
              <ListDescription className="comma">
                Дамир Есембаев
                <br />
                Максим Миронов
                <br />
                Анна Навумчик
              </ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Звукорежиссер</ListTerm>
              <ListDescription>Юрай Жак</ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Звукооператоры</ListTerm>
              <ListDescription className="comma">
                Ян Кайзер, Александер Макрев, Младен Марилович, Давид Рада,
                Ондржей Стеинер
              </ListDescription>
              <ListDescription className="comma">
                Ян Кайзер
                <br />
                Александер Макрев
                <br />
                Младен Марилович
                <br />
                Давид Рада
                <br />
                Ондржей Стеинер
              </ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Техническая группа</ListTerm>
              <ListDescription className="comma">
                Павел Забродский, Тэа Йованович, Вацлав Клотцберг
              </ListDescription>
              <ListDescription className="comma">
                Павел Забродский
                <br />
                Тэа Йованович
                <br />
                Вацлав Клотцберг
              </ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Режиссерская группа</ListTerm>
              <ListDescription className="comma">
                Алина Агатина, Дамир Есембаев, Татьяна Изофатова, Айбол
                Кожомуратов, Дмитрий Рыженков, Евгения Степченко
              </ListDescription>
              <ListDescription className="comma">
                Алина Агатина
                <br />
                Дамир Есембаев
                <br />
                Татьяна Изофатова
                <br />
                Айбол Кожомуратов
                <br />
                Дмитрий Рыженков
                <br />
                Евгения Степченко
              </ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Редакторы архива</ListTerm>
              <ListDescription className="comma">
                Юлия Крючкова, Ольга Широкова
              </ListDescription>
              <ListDescription className="comma">
                Юлия Крючкова
                <br />
                Ольга Широкова
              </ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Операционный директор</ListTerm>
              <ListDescription>Антон Золотых</ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Административная группа</ListTerm>
              <ListDescription className="comma">
                Тереза Беранкова, Юлия Маслова, Павел Миронов
              </ListDescription>
              <ListDescription className="comma">
                Тереза Беранкова
                <br />
                Юлия Маслова
                <br />
                Павел Миронов
              </ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Дизайн и верстка</ListTerm>
              <ListDescription>Александра Золотых</ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Digital-редакторка</ListTerm>
              <ListDescription>Кристина Закурдаева</ListDescription>
            </Pair>
            <Pair>
              <ListTerm>Разработка сайта</ListTerm>
              <ListDescription>Pangea Digital Dataviz Team</ListDescription>
            </Pair>
          </List>
        </Columns>
      </FooterInner>
      <SocialMedia />
    </FooterStyled>
  )
}
